import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetMockups } from 'domains/Mockup/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../CustomerFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const MockupFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [mockups] = useGetMockups()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'mockups',
    operand: 'array-contains'
  })

  return (
    <StyledDetails
      open={localStorage.getItem(`mockup-details-visibility`) === 'opened'}>
      <summary style={summaryStyles} onClick={() => onToggleDetails('mockup')}>
        {t('Mockup')}
      </summary>
      {mockups?.map((mockup, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(mockup)}
            onChange={() => onChange(mockup)}>
            <Text wordBreak="break-all">
              {mockup?.name || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

MockupFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default MockupFilter
